<template>
  <div class="card mgt-20px" id="avoirsLies"
       v-if="factureDetail.sousType === constantes.SOUS_TYPE_NORMAL
         && !isEdit
         && ((!isSensAchat || factureDetail.avoirsAffectes.length !== 0 )|| isVenteInterne)">
    <header class="header-card">
      <p>
        {{ $t('detailFacture.avoirsLies.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="is-pulled-left mgb-20px">
        {{ $t('detailFacture.avoirsLies.montantTotal')}}
        {{ montantTotalAvoir | formatDevise}}
      </div>
      <avoirs-lies id="avoir-lie" :factureDetail="factureDetail"></avoirs-lies>
    </div>
  </div>
</template>

<script>

import avoirsLies from '@/components/factures/detail/avoirsLies';
import { SENS_ACHAT, SOUS_TYPE_NORMAL } from '@/configuration/devisConf';

export default {
  props: {
    factureDetail: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
    isVenteInterne: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      constantes: {
        SOUS_TYPE_NORMAL,
      },
    };
  },
  components: {
    avoirsLies,
  },
  computed: {
    isSensAchat() {
      return this.factureDetail.sens === SENS_ACHAT;
    },
    montantTotalAvoir() {
      let montantTotalAvoir = 0;
      this.factureDetail.avoirsAffectes.forEach((avoirAffecte) => {
        montantTotalAvoir += avoirAffecte.montantTtc;
      });
      return montantTotalAvoir;
    },
  },
};

</script>
